import { render, staticRenderFns } from "./MobileWheelOfFortune.vue?vue&type=template&id=08584f5b&scoped=true&"
import script from "./MobileWheelOfFortune.vue?vue&type=script&lang=js&"
export * from "./MobileWheelOfFortune.vue?vue&type=script&lang=js&"
import style0 from "./MobileWheelOfFortune.vue?vue&type=style&index=0&id=08584f5b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08584f5b",
  null
  
)

export default component.exports